import {FC} from "react";
import {Badge} from "@interstate/components/Badge";
import {SparklesIcon} from "@interstate/components/Icons";

interface SyntheticBadgeProps {
  isSynthetic: boolean;
}

export const SyntheticBadge: FC<SyntheticBadgeProps> = ({isSynthetic}) => {
  if (!isSynthetic) return null;

  return (
    <Badge
      data-testid="synthetic-badge"
      variant="info"
      startIcon={<SparklesIcon />}
    >
      Synthetic
    </Badge>
  );
};
